import "@shopify/polaris/build/esm/styles.css";
import "./scss/main.css";
import "react-phone-input-2/lib/style.css";
import "rsuite/dist/rsuite.min.css";
import "./scss/ck_override.css";
import "./scss/tailwind.css";
import React from "react";
import ServiceProvider from "./services";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <ServiceProvider />
    </ErrorBoundary>
  );
}

export default App;
